import excludeById from './excludeById';
import sortByDate from './sortByDate';
import { IMessagesState } from 'types/messages';

export default function acceptSuccess(state: IMessagesState, payload: { id: any, isSuccess: boolean, content: any, message: any }) {
  // The acceptance succeeded, to update state to remove the message
  if (payload.isSuccess) {
    return {
      ...state,
      isRequesting: false,
      // Add the newly-accepted message to feed messages
      feedMessages: [payload.content, ...state.feedMessages].sort(sortByDate).reverse(),
      // Remove it from interactions
      interactions: excludeById(state.interactions, payload.id).sort(sortByDate).reverse(),
    };
  }

  // TODO: !IsSuccess => this is a failure, so we should handle it accordingly.
  return {
    ...state,
    dialogOpen: true,
    content: payload.content,
    dialogMessage: payload.message,
    isRequesting: false,
  };
}